// GENERATED by scripts/build-icons.mjs from icons/server.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Server = createIcon('server', [
  ['rect', { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2" }],
  ['rect', { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2" }],
  ['line', { x1: "6", x2: "6.01", y1: "6", y2: "6" }],
  ['line', { x1: "6", x2: "6.01", y1: "18", y2: "18" }],
])
